import * as Helpers from "@/helpers";

export default {
  getInstancePage(state) {
    return state.page;
  },
  getBasicAttributes(state) {
    return state.compBasicAttributes;
  },
  getAdditionalAttributes(state) {
    return state.compAdditionalAttributes;
  },
  getAllAttributes(state) {
    return state.compAllAttributes;
  },
  getLoading(state) {
    return state.loading;
  },
  getSyncDataFetchLoading(state) {
    return state.syncDataFetchLoading;
  },
  getIntroLoading(state) {
    return state.introLoading;
  },
  componentErrors(state) {
    return state.errors;
  },
  componentSuccess(state) {
    return state.success;
  },
  getInstanceInfo(state) {
    return state.compInstanceInfo;
  },
  getSyncInstanceInfo(state) {
    return state.syncCompInstanceInfo;
  },
  getSearchValue(state) {
    return state.search;
  },
  getFilteredInstanceInfo(state) {
    let list = state.compInstanceInfo;
    list = Helpers.searchInstanceTableFilterHelper(state.search, list);
    return list.reverse();
  },
  getFilteredIntroInstanceInfo(state) {
    let list = state.compIntroInstanceInfo;
    list = Helpers.searchInstanceTableFilterHelper(state.search, list);
    return list.reverse();
  },
  getSaveLoading(state) {
    return state.saveLoading;
  },
  getCopyLoading(state) {
    return state.copyLoading;
  },
  getDeleteLoading(state) {
    return state.deleteLoading;
  },
  getCreateLoading(state) {
    return state.createLoading;
  },
  getOperationMode(state) {
    return state.operation;
  },
  getInstanceDescription(state) {
    return state.description;
  },
  getSyncLoading(state) {
    return state.syncLoading;
  },

  // ********************* abi image slider *********************

  getSlideInstance(state) {
    return state.slideInstance;
  },
  getSlideAttribute(state) {
    return state.slideAttributes;
  },
  getSlideLoading(state) {
    return state.slideLoading;
  },
  getSliderCreateLoading(state) {
    return state.sliderCreateLoading;
  },
  getSliderUpdateLoading(state) {
    return state.sliderUpdateLoading;
  },
  getSliderCopyLoading(state) {
    return state.sliderCopyLoading;
  },

  // ********************* global instance search ****************

  getGlobalInstanceSearch(state) {
    return state.searchResult;
  },
  getGlobalInstanceLoading(state) {
    return state.searchLoading;
  },

  // ********************* component draft ***********************

  getInstanceDraft(state) {
    return state.compInstanceDraft;
  },
  draftModeStatus(state) {
    return state.draftMode;
  },
  getDraftSaveLoading(state) {
    return state.draftSaveLoading;
  },
  getDraftCreateLoading(state) {
    return state.draftCreateSaveLoading;
  },

  // ********************* notice ***********************
  getEmailDelayMessage(state) {
    return state.delayMessage;
  },
  getDelayMessageUpdateLoading(state) {
    return state.delayMessageUpdateLoading;
  },
  getDelayMessageFetchLoading(state) {
    return state.delayMessageFetchLoading;
  }
};
